// extracted by mini-css-extract-plugin
module.exports = {"villaTagClassName":"villa-tag-module__villaTagClassName___thW5S","tagIconContainer":"villa-tag-module__tagIconContainer___S4U8S","tagIcon":"villa-tag-module__tagIcon___7OVPO"};